import React from 'react';
import { MessageSquare, Truck, HardHat } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function AnnouncementBar() {
  const location = useLocation();
  const isContractors = location.pathname.includes('subcontractors') || location.pathname.includes('contractors');
  const bgColor = 'bg-[#1e6b30]';
  return <div className={`${bgColor} text-white py-2 px-4 text-xs sm:text-sm font-medium relative z-[60] transition-colors duration-300 border-b border-[#1a5f2a]`} data-id="element-107">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 sm:gap-4" data-id="element-108">
        <div className="flex items-center" data-id="element-109">
          <Truck className="w-4 h-4 mr-1.5 hidden sm:block" data-id="element-110" />
          <span className="hidden sm:inline" data-id="element-111">
            Bulk Delivery Across South King County
          </span>
          <span className="sm:hidden" data-id="element-112">Bulk Delivery Available</span>
        </div>
        <span className="opacity-50" data-id="element-113">|</span>
        <a href="tel:206-619-3742" className="flex items-center hover:text-white/80 transition-colors font-bold" data-id="element-114">
          (206) 619-3742
        </a>
        <span className="opacity-50" data-id="element-115">|</span>
        <Link to="/subcontractors" className="flex items-center text-white hover:text-white/80 transition-colors font-bold" data-id="element-116">
          <HardHat className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1" data-id="element-117" />
          Contractors
        </Link>
      </div>
    </div>;
}